import React from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import { useLogout } from '../../../Hooks/useLogout';

const HeaderLogout = () => {
  const { handleLogout } = useLogout();

  return (
    <li>
      <span className="header-logout">
        <SvgIcon iconId="logout" onClick={handleLogout} />
      </span>
    </li>
  );
};

export default HeaderLogout;
